import { Backdrop, Fade, Modal as MuiModal } from "@mui/material";

type BaseModalProps = {
  open: boolean;
  disableBackdropBlur?: boolean;
  children: JSX.Element | Array<JSX.Element | boolean>;
  className?: string;
  onClose?: (event: unknown, reason: "backdropClick" | "escapeKeyDown") => void;
  "aria-label"?: string;
  "aria-labelledby"?: string;
  "aria-description"?: string;
  "aria-describedby"?: string;
};

export const BaseModal = ({ children, disableBackdropBlur, ...props }: BaseModalProps) => {
  return (
    <MuiModal
      {...props}
      closeAfterTransition
      slots={{ backdrop: Backdrop }}
      slotProps={
        disableBackdropBlur
          ? {}
          : {
              backdrop: {
                timeout: 500,
                style: {
                  backdropFilter: "blur(6px)",
                  backgroundColor: "rgba(22, 19, 74, 0.4)",
                },
              },
            }
      }
    >
      <Fade in={props.open} timeout={500}>
        <div className="supportsRtl">{children}</div>
      </Fade>
    </MuiModal>
  );
};
